// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"25a06d82","453":"906add87","455":"6b11ce74"}[chunkId] + ".chunk.js";
};